import { EmailDomainsService as OvermapEmailDomainsService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class EmailDomainsService extends OvermapEmailDomainsService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
